<template>
   <b-modal ref="modal" :title="title" @hide="onHide" @cancel="onCancel" :centered="true" :visible="open" :ok-title="okTitle"
     :cancel-title="$t('general.cancel')" size="xl" @ok="saveModal" :ok-disabled="disabled" :static="true">
            <component v-bind:is="renderModalForm" :save="saveAct" :data="modalProps" :changeData="changeData" 
            :saveState="saveState" :modalName="modalName" :modalEvent="modalEvent" :formName="form" 
            :onComplete="onComplete" :getSignal="getSignal"></component>
    </b-modal>
</template>

<script>
    import i18n from '@/plugins/i18n';
    import Postpone from './Postpone';
    import Process from './Process';
    import SetState from './SetState';
    import NoteHistory from './NoteHistory';
    import PostponeList from './PostponeList';
    
    export default {
        name: "Modals",
        data: function(){
            return{
                title: '',
                okTitle: i18n.t('general.save'),
                disabled: false,
                saveAct: false,
                size: 'lg'
            }
        },
        components:{
            Postpone, Process, SetState, NoteHistory, PostponeList
        },
        props:{
            open: Boolean,
            modalEvent: Function,
            form: String,
            modalName: String,
            modalProps: Object,
            onComplete: Function,
            getSignal: Function,
        },
        computed:{
            renderModalForm: function(){
                if(this.modalName === "Postpone"){
                    this.title = !this.modalProps.allPostpone ? 
                        this.modalProps.account_info.name + " - " + this.modalProps.alarm_code + " " + this.modalProps.signal_settings.description :
                        i18n.t('signal.actions.bulkAll')
                    this.okTitle = i18n.t('signal.actions.bulk')
                    this.$store.dispatch('signal_group_list', {is_bulk_postpone: true})

                } else if(this.modalName === "Process"){
                    this.title = i18n.t('signal.actions.processAll')
                    this.okTitle = i18n.t('signal.actions.processAllOk')
                    this.$store.dispatch('signal_group_list', {is_bulk_process: true})

                }else if(this.modalName === "SetState"){
                    this.title = i18n.t('signal.actions.undoAlarm')
                    this.okTitle = i18n.t('signal.actions.undo')
                }else if(this.modalName === "NoteHistory"){
                    this.title = this.modalProps.account_info.name + " - " + this.modalProps.alarm_code + " " + this.modalProps.signal_settings.description 
                    this.okTitle = i18n.t('signal.actions.close')
                }else if(this.modalName === "PostponeList"){
                    this.title = i18n.t('signal.actions.bulkedSignals')
                    this.okTitle = i18n.t('signal.actions.close')
                    this.$store.dispatch('postponeSignals')
                }
                return this.modalName
            }
        },
        methods:{
            onHide: function(){
                if(!this.saveAct)
                    this.modalEvent(false)
            },
            onCancel: function(){
                this.saveState(false)
                if(!this.saveAct)
                    this.modalEvent(false)

            },
            saveState: function(val){
                this.saveAct = val
            },
            // Modal tamamlandığı zaman olacak event
            saveModal: async function(bvModalEvt){
                bvModalEvt.preventDefault()
                // Modalın içerisindeki watchı tetikler
                this.saveState(true)
            },
            changeData(val, name){
                this.modalProps[name] = val
            },
        },
        watch:{
            saveAct(){
                return false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/modals/index.vue